import React, { useMemo } from "react";
import { Switch, useRouteMatch } from "react-router-dom";

import { Card, CardContent, Grid } from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import { TabPanel } from "../../../tabPanel/TabPanel";
import { PersonalDetails } from "./interpreterFields/PersonalDetails";
import { Qualifications } from "./interpreterFields/Qualifications";
import { Notes } from "./interpreterFields/Notes";
import { Rates } from "./interpreterFields/Rates";
import { Languages } from "./interpreterFields/Languages";
import { Hours } from "./interpreterFields/Hours";

import AuthenticatedRoute from "../../../../middlewares/AuthenticatedRoute";
import { IBookings } from "../../../../components/pages/ibookings/IBookings";
import { Invoice } from "../../../../components/includes/Invoice/Invoice";
import { RemittanceLists } from "../../../../components/pages/payments/iRemittance/RemittanceLists";

import { TimesheetProvider } from "../../../../context/states/timeSheetState";
import { FileProvider } from "../../../../context/states/fileState";
import { InvoiceProvider } from "../../../../context/states/invoiceState";
import { RemittanceProvider } from "../../../../context/states/remittanceState";

export const EditForm = React.memo((props) => {
  const {
    classes,
    interpreter,
    handleBack,
    handleTabValue,
    handleGetProfileImage,
    intID,
    isAccessTo,
    username,
    role,
    availableTabs,
  } = props;
  let { path } = useRouteMatch();
  // const { id } = useParams();

  const fetchData = async () => {
    try {
      if (interpreter.photo) await handleGetProfileImage(interpreter.photo);
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    fetchData(); // eslint-disable-next-line
  }, []);

  const personalDetailForm = useMemo(
    () => (
      <PersonalDetails
        classes={classes}
        data={interpreter}
        handleClose={handleBack}
        isAccessTo={isAccessTo}
        username={username}
      />
    ),
    [classes, interpreter, handleBack, isAccessTo, username],
  );

  const languageForm = useMemo(
    () => (
      <Languages
        classes={classes}
        data={interpreter}
        handleClose={handleBack}
        isAccessTo={isAccessTo}
      />
    ),
    [classes, interpreter, handleBack, isAccessTo],
  );

  const qualificationForm = useMemo(
    () => (
      <Qualifications
        classes={classes}
        data={interpreter}
        handleClose={handleBack}
        isAccessTo={isAccessTo}
      />
    ),
    [classes, interpreter, handleBack, isAccessTo],
  );

  const notesForm = useMemo(
    () => (
      <Notes
        classes={classes}
        data={interpreter}
        handleClose={handleBack}
        isAccessTo={isAccessTo}
        username={username}
        role={role}
      />
    ),
    [classes, interpreter, handleBack, isAccessTo, username, role],
  );

  const ratesForm = useMemo(
    () => (
      <Rates
        classes={classes}
        data={interpreter}
        handleClose={handleBack}
        isAccessTo={isAccessTo}
      />
    ),
    [classes, interpreter, handleBack, isAccessTo],
  );
  const payments = <RemittanceLists adminUser={false} />;

  const activePermission = availableTabs?.[handleTabValue]?.permission;

  return (
    <>
      <Card>
        <CardContent style={{ padding: "10px 6px" }}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            {activePermission === "edit-booking.personal-details" &&
              personalDetailForm}

            {activePermission === "edit-booking.languages" && languageForm}

            {activePermission === "edit-booking.qualifications" &&
              qualificationForm}

            {activePermission === "edit-booking.notes" && notesForm}

            {activePermission === "edit-booking.rates" && ratesForm}

            {activePermission === "edit-booking.payment-details" && (
              <RemittanceProvider>{payments}</RemittanceProvider>
            )}

            {activePermission === "edit-booking.hours" && (
              <Hours data={interpreter} />
            )}

            {activePermission === "edit-booking.timesheets" && (
              <TimesheetProvider>
                <FileProvider>
                  <InvoiceProvider>
                    <Grid item xs={12}>
                      <Switch>
                        <AuthenticatedRoute exact path={path}>
                          <IBookings
                            title="Timesheet Tracker"
                            intID={intID}
                            interpreterTab={true}
                          />
                        </AuthenticatedRoute>

                        <AuthenticatedRoute
                          path={`${path}/invoice/:id/:iType/:clientInvoice`}
                        >
                          <Invoice />
                        </AuthenticatedRoute>
                      </Switch>
                    </Grid>
                  </InvoiceProvider>
                </FileProvider>
              </TimesheetProvider>
            )}
          </MuiPickersUtilsProvider>
        </CardContent>
      </Card>
    </>
  );
});
